<template>
  <div class="my_page_edit">
    <div class="my_page_display">
      <div class="my_page_title" :style="`flex: 0 0 ${!Number.isNaN(Number(titleWidth)) ? titleWidth + 'px' : titleWidth}`">{{ title }}</div>
      <div class="my_page_radio">
        <el-radio v-model="page.radioValue" :label="true">{{$t('view_form_dialog_add_form_213')}}</el-radio>
        <el-radio v-model="page.radioValue" :label="false">{{$t('view_back_top_index_105')}}</el-radio>
        <el-popover
          placement="top-start"
          width="270"
          trigger="hover"
          :content="$t('components_my_page_my_page_edit_2412')"
          transition="zoom"
        >
          <i class="icon_tips" slot="reference">?</i>
        </el-popover>
      </div>
    </div>
    <div class="my_page_size" v-if="page.radioValue" style="margin-left: 72px">
      <span>{{$t('components_my_page_my_page_edit_2413')}}</span>
      <my_input_int_number v-model="page.pageSize" :min="1" style="width: 60px;"></my_input_int_number>
      <span>{{$t('components_my_img_selecter_font_icon_store_2321')}}</span>
    </div>
    <div class="my_page_style" v-if="page.radioValue && widgetName !=='searchResults'">
      <div class="my_page_title" :style="`flex: 0 0 ${!Number.isNaN(Number(titleWidth)) ? titleWidth + 'px' : titleWidth}`">{{ styleTitle }}</div>
      <div class="my_page_style_type">
        <div
          class="my_page_type my_page_type1"
          :class="`lang_` + $store.state.app.web_language_wm"
          :data-active="page.pageStyle === 0"
          @click="change_type(0)"
        >
          <div class="active-icon el-icon-check"></div>
        </div>
        <div
          class="my_page_type my_page_type2"
          :class="`lang_` + $store.state.app.web_language_wm"
          :data-active="page.pageStyle === 1"
          @click="change_type(1)"
        >
          <div class="active-icon el-icon-check"></div>
        </div>
        <div
          class="my_page_type my_page_type3"
          :class="`lang_` + $store.state.app.web_language_wm"
          :data-active="page.pageStyle === 2"
          @click="change_type(2)"
        >
          <div class="active-icon el-icon-check"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'my_page_edit',
  props: {
    page: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: i18n.t('components_my_page_my_page_edit_2414')
    },
    titleWidth: {
      type: String,
      default: '40'
    },
    styleTitle: {
      type: String,
      default: i18n.t('components_my_page_my_page_edit_2415')
    },
    widgetName:{
      type:String,
      defalut:''
    }
  },
  data () {
    return {
      pageSize: parseInt(this.page.pageSize),
      pageSizeTemp: parseInt(this.page.pageSize)
    }
  },
  methods: {
    change_type (index) {
      this.page.pageStyle = index
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/css/global-variable.scss";
.my_page_edit {
  .my_page_title {
    display: inline-block;
    font-size: 13px;
    text-align: right;
    overflow: hidden;
    height: 32px;
    line-height: 32px;
  }
  .my_page_display {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 15px;
    .my_page_radio {
      margin-left: 8px;
      /deep/ .el-radio {
        margin-right: 15px;
        &:last-of-type {
          margin-right: 0;
        }
      }
      .icon_tips {
        display: inline-block;
        width: 18px;
        height: 18px;
        line-height: 16px;
        text-align: center;
        color: #d8d8d8;
        border: 1px solid #d8d8d8;
        border-radius: 50%;
        cursor: pointer;
      }
    }
  }
  .my_page_size {
    margin-bottom: 15px;
    /deep/ .el-input {
      .el-input__inner {
        text-align: center;
      }
    }
  }
  .my_page_style {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    .my_page_title {
      height: 48px;
      line-height: 48px;
    }
    .my_page_style_type {
      margin-left: 8px;
      .my_page_type {
        position: relative;
        margin-bottom: 10px;
        width: 208px;
        height: 48px;
        border: 1px solid #e3e2e8;
        background: url(~@/assets/image/module_bg.png) no-repeat;
        cursor: pointer;
        &.lang_en{
          background: url(~@/assets/image/module_bg_en.png) no-repeat;
        }
        &.lang_tc{
          background: url(~@/assets/image/module_bg_tc.png) no-repeat;
        }
        .active-icon {
          display: none;
          width: 18px;
          height: 16px;
          color: #fff;
          position: absolute;
          bottom: 0;
          right: 0;
          background-color: $theme-primary;
          line-height: 22px;
          font-size: 12px;
          padding: 0 3px;
          border-top-left-radius: 100%;
        }
        &[data-active] {
          border: 1px solid $theme-primary;
          .active-icon {
            display: block;
          }
        }
        &.my_page_type1 {
          background-position: -527px -10px;
          &.lang_en, &.lang_tc{
            background-position: -522px 2px;            
          }
        }
        &.my_page_type2 {
          background-position: -527px -64px;
           &.lang_en, &.lang_tc{
            background-position: -522px -54px;
          }
        }
        &.my_page_type3 {
          margin-bottom: 0;
          background-position: -527px -120px;
           &.lang_en, &.lang_tc{
            background-position: -522px -110px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my_page/my_page_edit.vue